var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriseenEnterpriseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 132.58 34.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #00b395;\n      }\n\n      .cls-3 {\n        fill: #fbb03b;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "132.58 7.14 125.45 7.14 125.45 0 132.58 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 66.79,
    y: 24.59,
    width: 58.58,
    height: 10.11,
    rx: 3,
    ry: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.12,26.6V7.48h3.13v3.31l-.13,3.73.26,3.73v8.35h-3.26ZM45.87,21.69c-1.16,0-2.2-.26-3.13-.77s-1.66-1.31-2.21-2.38c-.54-1.07-.81-2.42-.81-4.04s.26-3,.77-4.06,1.25-1.85,2.19-2.36c.95-.52,2-.77,3.18-.77,1.37,0,2.58.3,3.65.89,1.07.6,1.91,1.44,2.53,2.52.62,1.09.93,2.35.93,3.78s-.31,2.72-.93,3.79-1.47,1.91-2.53,2.51c-1.07.6-2.29.89-3.65.89ZM45.48,18.91c.81,0,1.52-.18,2.14-.55.62-.37,1.12-.88,1.48-1.55.37-.67.55-1.44.55-2.31s-.18-1.67-.55-2.33c-.37-.66-.86-1.16-1.48-1.52-.62-.36-1.34-.54-2.14-.54s-1.47.18-2.1.54c-.63.36-1.13.87-1.5,1.52-.37.66-.55,1.43-.55,2.33s.18,1.65.55,2.31c.37.67.87,1.18,1.5,1.55.63.37,1.33.55,2.1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.57,21.51V7.48h3.13v3.86l-.37-1.13c.4-.95,1.06-1.67,1.97-2.17.91-.5,2.02-.75,3.34-.75v3.12c-.12-.02-.25-.03-.37-.04s-.24-.01-.34-.01c-1.26,0-2.26.36-2.99,1.08-.74.72-1.1,1.81-1.1,3.28v6.78h-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.52,5.17c-.61,0-1.12-.19-1.51-.58-.39-.38-.59-.86-.59-1.42,0-.53.2-.98.59-1.37.39-.38.9-.58,1.51-.58s1.12.18,1.51.54c.39.36.59.82.59,1.38s-.19,1.04-.58,1.43c-.39.39-.89.59-1.52.59ZM63.89,21.51V7.48h3.26v14.03h-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.24,21.69c-1.19,0-2.32-.15-3.39-.46-1.07-.31-1.93-.68-2.57-1.12l1.26-2.5c.63.4,1.38.73,2.26.99.88.25,1.76.38,2.65.38,1.02,0,1.76-.14,2.22-.41.46-.27.7-.64.7-1.12,0-.38-.16-.68-.47-.88-.32-.2-.73-.35-1.23-.46-.51-.1-1.07-.2-1.69-.29-.62-.09-1.24-.21-1.86-.35-.62-.15-1.19-.37-1.69-.66-.51-.29-.92-.68-1.23-1.17-.32-.49-.47-1.15-.47-1.97,0-.88.25-1.64.76-2.3s1.22-1.17,2.14-1.54c.92-.37,2.01-.55,3.27-.55.93,0,1.88.11,2.85.33.97.22,1.78.52,2.43.91l-1.29,2.5c-.65-.38-1.31-.65-2-.8s-1.36-.22-2.02-.22c-.98,0-1.72.14-2.21.43s-.74.66-.74,1.12c0,.42.16.74.47.95.32.21.73.37,1.23.49.51.11,1.07.22,1.69.32.62.1,1.24.22,1.85.37.61.15,1.18.36,1.69.63s.93.65,1.25,1.14c.31.49.47,1.13.47,1.92,0,.89-.26,1.66-.77,2.3-.52.64-1.24,1.14-2.18,1.5-.94.36-2.06.54-3.38.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.42,21.69c-1.56,0-2.92-.31-4.08-.93-1.16-.62-2.07-1.47-2.71-2.55-.64-1.08-.96-2.32-.96-3.72s.31-2.64.93-3.72c.62-1.08,1.48-1.93,2.57-2.55,1.09-.62,2.34-.93,3.74-.93s2.58.3,3.65.91c1.07.6,1.91,1.45,2.52,2.53.61,1.09.92,2.37.92,3.86,0,.12,0,.28-.01.46s-.02.35-.04.49h-11.69v-2.18h9.95l-1.31.68c.02-.79-.14-1.49-.49-2.11-.34-.62-.81-1.1-1.41-1.44-.6-.34-1.3-.51-2.1-.51s-1.49.17-2.11.51c-.62.34-1.1.83-1.43,1.46-.33.63-.5,1.36-.5,2.18v.53c0,.84.19,1.58.56,2.23.38.65.92,1.15,1.62,1.51.7.36,1.51.54,2.44.54.79,0,1.5-.13,2.13-.39s1.19-.65,1.68-1.16l1.79,2.05c-.65.74-1.45,1.3-2.4,1.68-.95.38-2.04.58-3.27.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.19,21.69c-1.56,0-2.92-.31-4.08-.93-1.16-.62-2.07-1.47-2.71-2.55-.64-1.08-.96-2.32-.96-3.72s.31-2.64.93-3.72c.62-1.08,1.48-1.93,2.57-2.55,1.09-.62,2.34-.93,3.74-.93s2.58.3,3.65.91c1.07.6,1.91,1.45,2.52,2.53.61,1.09.92,2.37.92,3.86,0,.12,0,.28-.01.46s-.02.35-.04.49h-11.69v-2.18h9.95l-1.31.68c.02-.79-.14-1.49-.49-2.11-.34-.62-.81-1.1-1.41-1.44-.6-.34-1.3-.51-2.1-.51s-1.49.17-2.11.51c-.62.34-1.1.83-1.43,1.46-.33.63-.5,1.36-.5,2.18v.53c0,.84.19,1.58.56,2.23.38.65.92,1.15,1.62,1.51.7.36,1.51.54,2.44.54.79,0,1.5-.13,2.13-.39s1.19-.65,1.68-1.16l1.79,2.05c-.65.74-1.45,1.3-2.4,1.68-.95.38-2.04.58-3.27.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31,7.3c1.14,0,2.14.22,3.01.66.87.44,1.56,1.11,2.07,2.02.52.91.77,2.08.77,3.49v8.04h-3.28v-7.62c0-1.24-.29-2.17-.87-2.78s-1.4-.92-2.47-.92c-.77,0-1.45.16-2.05.47-.6.31-1.06.78-1.38,1.41-.32.62-.49,1.41-.49,2.35v7.09h-3.26V7.48h3.13v3.81l-.55-1.18c.47-.89,1.18-1.58,2.11-2.08.94-.49,2.02-.74,3.24-.74Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 9.36,
    width: 0.47,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.56,
    y: 9.36,
    width: 0.46,
    height: 11.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.39,
    y: 9.36,
    width: 0.46,
    height: 11.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.06,
    y: 9.36,
    width: 1.39,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.06,
    y: 9.36,
    width: 0.46,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4.48,
    y: 9.36,
    width: 0.46,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.98,
    y: 9.36,
    width: 0.46,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 7.56,
    y: 9.36,
    width: 0.46,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.87,
    y: 9.36,
    width: 0.97,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.84,
    y: 9.36,
    width: 0.97,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.84,
    y: 9.36,
    width: 1.39,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 12.57,
    y: 9.36,
    width: 0.62,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.72,
    y: 9.36,
    width: 0.62,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.68,
    y: 9.36,
    width: 0.46,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.4,
    y: 9.36,
    width: 0.99,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 20.34,
    y: 9.36,
    width: 0.46,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.64,
    y: 9.36,
    width: 0.97,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.34,
    y: 9.36,
    width: 0.62,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.45,
    y: 9.36,
    width: 0.46,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.17,
    y: 9.36,
    width: 0.99,
    height: 11.54
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.03,
    y: 26.36,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.1 .05) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 26.33,
    width: 0.28,
    height: 2.4,
    transform: "translate(-.1 .09) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.74,
    y: 26.33,
    width: 0.28,
    height: 2.4,
    transform: "translate(-.1 .09) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.68,
    y: 26.36,
    width: 0.84,
    height: 2.42,
    transform: "translate(-.1 .05) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.88,
    y: 26.36,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.1 .05) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.74,
    y: 26.35,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.1 .06) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.64,
    y: 26.35,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.1 .06) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.6,
    y: 26.35,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.1 .06) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 26.34,
    width: 0.59,
    height: 2.42,
    transform: "translate(-.1 .07) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.39,
    y: 26.34,
    width: 0.59,
    height: 2.42,
    transform: "translate(-.1 .08) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2,
    y: 26.33,
    width: 0.84,
    height: 2.42,
    transform: "translate(-.1 .08) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.63,
    y: 26.34,
    width: 0.38,
    height: 2.42,
    transform: "translate(-.1 .07) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.53,
    y: 26.33,
    width: 0.38,
    height: 2.42,
    transform: "translate(-.1 .08) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.28,
    y: 26.35,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.1 .07) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.71,
    y: 26.34,
    width: 0.6,
    height: 2.42,
    transform: "translate(-.1 .07) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.32,
    y: 26.33,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.1 .09) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.31,
    y: 26.32,
    width: 0.59,
    height: 2.42,
    transform: "translate(-.1 .1) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.34,
    y: 26.32,
    width: 0.38,
    height: 2.42,
    transform: "translate(-.1 .1) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.99,
    y: 26.32,
    width: 0.28,
    height: 2.42,
    transform: "translate(-.1 .09) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.42,
    y: 26.32,
    width: 0.6,
    height: 2.42,
    transform: "translate(-.1 .1) rotate(-.21)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.13 21.81 7.03 21.81 6.52 28.67 12.64 28.8 12.69 26.41 9.85 26.36 10.13 21.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,25.31l19.14-.11-2.33-20.15h-3.76c-.11,0-.23-.02-.33-.07-.3-.14-.53-.36-.66-.5-.05-.05-.08-.11-.12-.17l-.62-1.21-.04-.08c-.36-.59-1.02-.95-1.71-.95h-.01l-6.64.04c-.74,0-1.41.41-1.75,1.07l-.57,1.19c-.07.15-.18.29-.32.38-.18.13-.38.21-.54.26-.08.02-.16.04-.24.04h-4.1s-.21,3.52-.21,3.52h2.78s.04-.97.04-.97l11.41.03h4.92s1.42,14.6,1.42,14.6l-15.71.2-.05,2.88ZM15.17,5.06l.29-.6c.08-.16.24-.27.42-.27l5.9-.03c.22,0,.42.12.52.32l.3.58h-7.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.84,31.76c-.4,0-.75-.08-1.05-.25-.3-.16-.53-.39-.7-.67-.17-.28-.25-.61-.25-.98s.08-.7.24-.98c.16-.28.38-.51.67-.67.28-.16.6-.24.96-.24s.68.08.95.24c.28.16.49.38.65.67s.23.62.23,1c0,.03,0,.06,0,.1,0,.04,0,.07-.01.11h-3.16v-.48h2.81l-.27.17c0-.24-.04-.45-.15-.64s-.24-.33-.42-.44c-.18-.11-.39-.16-.63-.16s-.44.05-.62.16c-.18.11-.32.25-.43.44-.1.19-.15.4-.15.65v.11c0,.25.06.47.17.66.11.19.27.34.48.45.21.11.44.16.71.16.22,0,.42-.04.6-.11.18-.07.34-.19.47-.34l.37.43c-.17.2-.38.34-.63.45s-.53.15-.84.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.45,27.97c.3,0,.57.06.8.17.23.12.41.29.54.53s.2.54.2.9v2.13h-.67v-2.06c0-.36-.09-.63-.26-.81-.18-.18-.42-.27-.74-.27-.24,0-.45.05-.62.14s-.31.23-.41.41c-.1.18-.14.41-.14.68v1.91h-.67v-3.71h.64v1l-.1-.27c.12-.24.31-.43.56-.57s.55-.2.88-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.71,28.56v-.55h2.37v.55h-2.37ZM89.51,31.76c-.37,0-.66-.1-.87-.3-.21-.2-.31-.49-.31-.86v-3.4h.67v3.37c0,.2.05.36.15.46.1.11.24.16.43.16.21,0,.39-.06.53-.17l.21.48c-.1.09-.23.15-.37.2-.14.04-.29.06-.44.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.66,31.76c-.4,0-.75-.08-1.05-.25-.3-.16-.53-.39-.7-.67-.17-.28-.25-.61-.25-.98s.08-.7.24-.98c.16-.28.38-.51.67-.67.28-.16.6-.24.96-.24s.68.08.95.24c.28.16.49.38.65.67s.23.62.23,1c0,.03,0,.06,0,.1,0,.04,0,.07-.01.11h-3.16v-.48h2.81l-.27.17c0-.24-.04-.45-.15-.64s-.24-.33-.42-.44c-.18-.11-.39-.16-.63-.16s-.44.05-.62.16c-.18.11-.32.25-.43.44-.1.19-.15.4-.15.65v.11c0,.25.06.47.17.66.11.19.27.34.48.45.21.11.44.16.71.16.22,0,.42-.04.6-.11.18-.07.34-.19.47-.34l.37.43c-.17.2-.38.34-.63.45s-.53.15-.84.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3,31.72v-3.71h.64v1.01l-.06-.25c.1-.26.28-.45.52-.59s.54-.2.9-.2v.65s-.05,0-.08,0h-.07c-.36,0-.64.11-.85.32-.21.21-.31.53-.31.93v1.85h-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.12,33.08v-5.07h.64v1l-.04.86.07.86v2.35h-.67ZM100.08,31.76c-.31,0-.59-.07-.84-.21-.25-.14-.46-.35-.61-.63-.15-.28-.23-.63-.23-1.05s.07-.77.22-1.05c.15-.28.35-.49.6-.63.25-.14.54-.21.86-.21.36,0,.69.08.97.24.28.16.5.38.67.66.16.28.25.61.25.99s-.08.71-.25.99c-.16.29-.38.51-.67.67-.28.16-.6.24-.97.24ZM100.03,31.17c.24,0,.45-.05.64-.16s.34-.26.45-.46c.11-.2.16-.43.16-.69s-.05-.5-.16-.69c-.11-.19-.26-.34-.45-.45s-.4-.16-.64-.16-.44.05-.63.16-.34.26-.45.45c-.11.19-.16.42-.16.69s.06.49.16.69c.11.2.26.35.45.46s.4.16.63.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.89,31.72v-3.71h.64v1.01l-.06-.25c.1-.26.28-.45.52-.59s.54-.2.9-.2v.65s-.05,0-.08,0h-.07c-.36,0-.64.11-.85.32-.21.21-.31.53-.31.93v1.85h-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.05,27.3c-.13,0-.24-.04-.33-.13s-.13-.19-.13-.31.04-.23.13-.31.19-.13.33-.13.24.04.33.12c.09.08.13.18.13.3s-.04.23-.13.32c-.08.09-.19.13-.33.13ZM105.71,31.72v-3.71h.67v3.71h-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.73,31.76c-.31,0-.6-.04-.88-.13-.28-.08-.5-.19-.65-.31l.28-.53c.16.11.35.2.59.27.23.08.47.11.71.11.31,0,.54-.04.68-.13s.21-.21.21-.37c0-.12-.04-.21-.13-.27-.08-.06-.19-.11-.33-.15s-.29-.06-.46-.09c-.17-.03-.34-.06-.5-.1s-.32-.1-.46-.17-.25-.17-.34-.3c-.08-.13-.13-.3-.13-.51s.06-.42.19-.59.3-.3.54-.39c.23-.09.5-.14.82-.14.24,0,.49.03.74.09.25.06.45.14.61.25l-.29.53c-.17-.11-.34-.19-.52-.23s-.36-.06-.55-.06c-.29,0-.51.05-.66.14s-.22.22-.22.37c0,.13.04.22.13.29.09.07.2.12.34.16s.29.07.46.09c.17.03.34.06.5.1s.32.09.46.16c.14.07.25.17.34.29s.13.29.13.5c0,.22-.07.42-.2.58-.13.16-.31.29-.55.38-.24.09-.52.14-.85.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.82,31.76c-.4,0-.75-.08-1.05-.25-.3-.16-.53-.39-.7-.67-.17-.28-.25-.61-.25-.98s.08-.7.24-.98c.16-.28.38-.51.67-.67.28-.16.6-.24.96-.24s.68.08.95.24c.28.16.49.38.65.67s.23.62.23,1c0,.03,0,.06,0,.1,0,.04,0,.07-.01.11h-3.16v-.48h2.81l-.27.17c0-.24-.04-.45-.15-.64s-.24-.33-.42-.44c-.18-.11-.39-.16-.63-.16s-.44.05-.62.16c-.18.11-.32.25-.43.44-.1.19-.15.4-.15.65v.11c0,.25.06.47.17.66.11.19.27.34.48.45.21.11.44.16.71.16.22,0,.42-.04.6-.11.18-.07.34-.19.47-.34l.37.43c-.17.2-.38.34-.63.45s-.53.15-.84.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.01,0c-1.97,0-3.57,1.6-3.57,3.57s1.6,3.57,3.57,3.57,3.57-1.6,3.57-3.57-1.6-3.57-3.57-3.57ZM129.01.71c1.58,0,2.85,1.27,2.85,2.85s-1.27,2.85-2.85,2.85-2.85-1.27-2.85-2.85,1.27-2.85,2.85-2.85ZM127.94,2.14v2.85h.59v-1.05h.47l.54,1.05h.63v-.03l-.62-1.17c.08-.04.15-.08.21-.13.06-.05.12-.11.16-.17.04-.06.08-.14.1-.22.02-.08.04-.18.04-.28,0-.14-.02-.27-.07-.37-.05-.11-.12-.2-.21-.27-.09-.07-.2-.13-.33-.17-.13-.04-.28-.06-.44-.06h-1.06ZM128.53,2.62h.47c.16,0,.28.04.35.12s.11.18.11.32c0,.06,0,.12-.03.17-.02.05-.05.1-.09.13-.04.04-.09.07-.14.09-.06.02-.13.03-.2.03h-.47v-.86Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriseenEnterpriseLogo);
export default __webpack_public_path__ + "static/media/priseen-enterprise-logo.3a4b0d515bda94331a58980805359bc9.svg";
export { ForwardRef as ReactComponent };